
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 20 20","fill":"currentColor","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","d":"M2.451 3.989A.75.75 0 013 3.75h14a.75.75 0 01.748.803l-.867 12.143a2.75 2.75 0 01-2.743 2.554H5.862a2.75 2.75 0 01-2.743-2.554L2.252 4.553a.75.75 0 01.2-.564zM3.805 5.25l.81 11.34a1.25 1.25 0 001.247 1.16h8.276c.656 0 1.2-.507 1.247-1.16l.81-11.34H3.805z","clip-rule":"evenodd"}}),_c('path',{attrs:{"fill-rule":"evenodd","d":"M1.25 4.5A.75.75 0 012 3.75h16a.75.75 0 010 1.5H2a.75.75 0 01-.75-.75z","clip-rule":"evenodd"}}),_c('path',{attrs:{"fill-rule":"evenodd","d":"M6.947 1.804a1.893 1.893 0 011.338-.554h3.429a1.893 1.893 0 011.893 1.893v1.143a.75.75 0 01-.75.75H7.143a.75.75 0 01-.75-.75V3.143c0-.502.199-.984.554-1.339zm1.338.946a.393.393 0 00-.392.393v.393h4.214v-.393a.393.393 0 00-.393-.393H8.285zm.001 4.786a.75.75 0 01.75.75V14a.75.75 0 01-1.5 0V8.286a.75.75 0 01.75-.75zm3.428 0a.75.75 0 01.75.75V14a.75.75 0 01-1.5 0V8.286a.75.75 0 01.75-.75z","clip-rule":"evenodd"}})])
          )
        }
      }
    